import React, { createContext, useEffect, useState } from 'react';
import { 
  ThemeContext, 
  getStoredTheme, 
  setStoredTheme, 
  applyTheme, 
  resolveTheme, 
  getSystemTheme 
} from '../../hooks/useTheme';

type Theme = 'dark' | 'light' | 'system';

interface ThemeProviderProps {
  children: React.ReactNode;
  defaultTheme?: Theme;
}

export function ThemeProvider({ children, defaultTheme = 'dark' }: ThemeProviderProps) {
  const [theme, setThemeState] = useState<Theme>('dark' as Theme); // Forzar dark mode

  const [resolvedTheme, setResolvedTheme] = useState<'dark'>('dark'); // Solo dark

  const setTheme = (newTheme: Theme) => {
    // Siempre dark, ignorar cambios
    setThemeState('dark');
    setStoredTheme('dark');
    setResolvedTheme('dark');
    applyTheme('dark');
  };

  useEffect(() => {
    // Forzar tema oscuro siempre
    setResolvedTheme('dark');
    applyTheme('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  }, []);

  const value = {
    theme: 'dark' as Theme,
    setTheme,
    resolvedTheme: 'dark' as 'dark',
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}